import { ACTION_LIST } from "@/constants/robotConfigLists";
import { ActionType } from "@/types/ses/sesItemConfigTypes";
import {
	faArrowDownAZ,
	faArrowRight,
	faBan,
	faChartLine,
	faCheck,
	faCommentDots,
	faComments,
	faDatabase,
	faDice,
	faEraser,
	faExchangeAlt,
	faFlagCheckered,
	faGear,
	faGlobe,
	faPaperclip,
	faQuestion,
	faTerminal,
	IconDefinition,
} from "@fortawesome/free-solid-svg-icons";
import { TExtendedAction, IExtendedActionItem } from "./ActionEvent.props";

export const ACTION_ICONS: Record<TExtendedAction, IconDefinition> = {
	say: faCommentDots,
	confirmation: faCheck,
	sendfile: faPaperclip,
	setvariable: faGear,
	goto: faArrowRight,
	break: faBan,
	transfer: faExchangeAlt,
	declinedata: faEraser,
	end: faFlagCheckered,
	"qas-chat": faComments,
	"qas-ask": faQuestion,
	external: faTerminal,
	setreport: faChartLine,
};

export const ACTION_TYPE_ICONS: Record<ActionType, IconDefinition> = {
	linear: faArrowDownAZ,
	random: faDice,
	internal: faDatabase,
	external: faGlobe,
};

export const EXTENDED_ACTION_LIST: IExtendedActionItem[] = [
	...ACTION_LIST.map((el) => ({ value: el.action, label: el.translation })),
	{ value: "qas-chat", label: "selectItem_llmChat" },
	{ value: "qas-ask", label: "selectItem_qasRequest" },
	{ value: "external", label: "selectItem_runScript" },
];
